/* Virtual Office tier metadata (frontend mirror of backend TIER_DEFS) */
export const VO_TIERS = [
  {
    id: 'address',
    name: 'Clayworks Address',
    tagline: 'Brand presence only',
    bestFor: 'Startups, freelancers, consultants, agencies, and remote businesses that only need a professional business address.',
    features: [
      'Exclusive use of Clayworks center address',
      'Mail and courier acceptance',
      'Visitor acknowledgment',
      'Invitations to Clayworks community events',
      'Preferential pricing on Day Passes and Meeting Rooms',
    ],
    excludes: ['GST registration documentation', 'Company registration support', 'Physical workspace access'],
    badge: null,
    accent: 'border-slate-200 dark:border-slate-700',
  },
  {
    id: 'address_gst',
    name: 'Clayworks Address + GST',
    tagline: 'Most popular',
    bestFor: 'Businesses requiring GST registration using a commercial address.',
    features: [
      'Everything in Clayworks Address',
      'GST registration documentation support',
      'Compliance-ready documentation for GST registration',
      'Business address, mail handling, visitor acknowledgment',
      'Community event access',
      'Preferential meeting room and day pass rates',
    ],
    excludes: ['Company registration support', 'Physical workspace access'],
    badge: 'Most Popular',
    accent: 'border-primary ring-2 ring-primary/30',
  },
  {
    id: 'address_gst_registration',
    name: 'Clayworks Address + GST + Registration',
    tagline: 'Full compliance setup',
    bestFor: 'Companies requiring both GST registration and office/company registration support.',
    features: [
      'Everything in Address + GST',
      'Documentation support for office/company registration',
      'Business address, mail handling, visitor acknowledgment',
      'Community event access',
      'Preferential meeting room and day pass pricing',
    ],
    excludes: ['Physical workspace access'],
    badge: null,
    accent: 'border-slate-200 dark:border-slate-700',
  },
  {
    id: 'vo_access',
    name: 'Clayworks VO Access',
    tagline: 'Virtual office + occasional workspace',
    bestFor: 'Businesses that want a virtual office plus occasional physical workspace access.',
    features: [
      'Everything in Address + GST + Registration',
      '3 complimentary Day Passes every month at the home center',
      '15 credits/month auto-allocated (usable for Day Passes OR Meeting Rooms)',
      'Registration & GST documentation support',
      'Business address, mail handling, visitor acknowledgment',
      'Community event access',
      'Preferential meeting room rates',
    ],
    excludes: [],
    badge: 'Premium',
    accent: 'border-amber-400 ring-2 ring-amber-400/30',
  },
];

export const VO_TIER_MAP = VO_TIERS.reduce((acc, t) => ({ ...acc, [t.id]: t }), {});

export const VO_COMPARISON_FEATURES = [
  { label: 'Business Address', tiers: { address: true, address_gst: true, address_gst_registration: true, vo_access: true } },
  { label: 'Mail Handling', tiers: { address: true, address_gst: true, address_gst_registration: true, vo_access: true } },
  { label: 'Visitor Acknowledgment', tiers: { address: true, address_gst: true, address_gst_registration: true, vo_access: true } },
  { label: 'Community Event Access', tiers: { address: true, address_gst: true, address_gst_registration: true, vo_access: true } },
  { label: 'Meeting Room Discounts', tiers: { address: true, address_gst: true, address_gst_registration: true, vo_access: true } },
  { label: 'GST Documentation Support', tiers: { address: false, address_gst: true, address_gst_registration: true, vo_access: true } },
  { label: 'Office Registration Support', tiers: { address: false, address_gst: false, address_gst_registration: true, vo_access: true } },
  { label: 'Complimentary Day Passes', tiers: { address: false, address_gst: false, address_gst_registration: false, vo_access: '3/month' } },
];

export const VO_COMMERCIAL_TERMS = {
  contract: [
    'Minimum commitment: 12 months',
    'Full payment required upfront (annual)',
    'No security deposit',
    'Prices are exclusive of GST/taxes',
    'Fixed and non-negotiable pricing',
    'Available only at select Clayworks centers',
  ],
  compliance: [
    'PAN Card mandatory',
    'Aadhaar Card mandatory',
    'KYC of authorized signatory required',
    'Registrations subject to statutory approvals',
  ],
  note: 'Registration support is facilitated through authorized partners, but final approval depends on government authorities.',
};
